#import "src/queries/fragments/tagFragment.graphql"

fragment TagsEditorEntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  entityType
  tag {
    id
    displayValue
    type
    attributes
    appliedCount @include(if: $includeAppliedCount)
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}
